import React, { PureComponent, Fragment } from 'react';
import Radio from 'antd/lib/radio';

import {
  imageBasePath,
  translatedLabels,
  // isDevelopment,
} from '../../library/constants';

import {
  // getNodeFromNodeObjsWithPrId,
  // doWhenReady,
  isMobilePhone,
} from '../../library/calc';

class Base extends PureComponent {

  defaultMockSiblingRows = 4
  defaultHeightOfMockCallOutContainer = 116
  defaultHeadersHeight = 27;
  defaultHeadersHeightSinglePartner = (this.defaultHeadersHeight/* parent, siblings, children partners*/ * 4/*num*/)
  defaultHeadersHeightMultiPartner = (this.defaultHeadersHeight/* parent, siblings, children partners*/ * 2/*num*/) + ( 43 /* height of parents and children header */)
  maxHeightOfCallOutContainer = this.props.canvasHeight
  pixelsHeightForEachDomRow = 22
  addSonAndDaughterDivHeight = 22
  numberOfPartners = 0
  extraHeightForMultiplePartners = 0
  combineHeightOfHrSeparatorsSinglePartner = (3/*num*/ * this.pixelsHeightForEachDomRow /*px each*/);
  combineHeightOfHrSeparatorsMultiPartner = (2/*num*/ * this.pixelsHeightForEachDomRow /*px each*/);
  marginOfInnerTableWrapper = 30 /* top and bottom */;
  heightOfCallOutContainerStyle = 0

  state = {
    fetchLoaded:false,
  }

  hasOnlyOnePartner(){
    // const { nodeObjs, addNodeFormFocus} = this.props;
    const immediateFam = this.props.nodeObj.immediateFam;
    return immediateFam.partners.length <= 1
  }

  getNodeObjFromImmedFamily({nodeId, arrayOfNodeObjs}){

    const filteredArrayOfObjs = arrayOfNodeObjs.filter((nodeObj)=>{
      return nodeObj.n.toString() === nodeId.toString();
    });

    return filteredArrayOfObjs[0];
  }

  immediateFamilyIsFetched(){
    return  typeof(this.props.nodeObj) !== 'undefined' &&
    typeof(this.props.nodeObj.immediateFam) !== 'undefined'
  }

  noImmediateFamily(){

    const isBool =
    typeof(this.props.nodeObj) !== 'undefined' &&
    typeof(this.props.nodeObj.immediateFam) !== 'undefined' &&
    typeof(this.props.nodeObj.immediateFam.parents) !== 'undefined' && this.props.nodeObj.immediateFam.parents.length === 0 &&
    typeof(this.props.nodeObj.immediateFam.siblings) !== 'undefined' && this.props.nodeObj.immediateFam.siblings.length === 0 &&
    typeof(this.props.nodeObj.immediateFam.children) !== 'undefined' && this.props.nodeObj.immediateFam.children.length === 0 &&
    typeof(this.props.nodeObj.immediateFam.partners) !== 'undefined' && this.props.nodeObj.immediateFam.partners.length === 0

    return isBool;

  }

  canAddNode(){
    if(this.props.nodeObj.a === 1){
      return true;
    }
    return false;
  }

  onClick(nodeObj){

    if(this.props.disableClick) return;

    if(isMobilePhone()){
      this.onMobileTouch(nodeObj);
      return;
    }

    if( this.props.isPedigree &&
        this.props.immediateFamVersion === 'flipPanel') {
          this.props.setPedigreeAddbox({visible: false});
    }

    this.props.clickforImmediateFamily({
      nodeObj,
      doWhatToFlipNodeCrumbs: 'add',
      immediateFamVersion: this.props.immediateFamVersion,
      setFetchIsLoading:( isMobilePhone() ? this.props.setFetchIsLoading: undefined)
    });

    /*

      if(!isMobilePhone()){
      } else{
        this.props.setNodeForFlipFocus();
        console.log('foo foo foo ');
      }
     */
  }

  getIconStyle(){

    const icon = {
      float: 'right',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      cursor: 'pointer',
      opacity: .6,
    }

    const edit = {
      backgroundImage: `url(${imageBasePath}node/edit.svg)`,
      ...icon,
      width: '12px',
      height: '12px',
    };

    const tree = {
      backgroundImage: `url(${imageBasePath}node/tree.svg)`,
      backgroundPosition: `center 4px`,
      ...icon,
      verticalAlign: 'bottom',
      width: '16px',
      height: '16px',
    };

    return {
      edit,
      tree,
    }
  }

  buildAddLinks({openAddNodeForm, maleRelation, femaleRelation, node, marriageId}){
    return (
      <span>
        <span
          onClick={()=>{
            openAddNodeForm({
              node,
              relationShip: maleRelation,
              marriageId
            });
          }}
          className='addlink-anchor-tag'
        >
          {translatedLabels[`Add ${maleRelation}`].translatedLabel}
        </span><span style={{fontWeight: 'normal'}}>&nbsp;{( this.props.immediateFamVersion === 'flipPanel' ? '': '|' )}&nbsp;</span>
        <span
          onClick={()=>{
            openAddNodeForm({
              node,
              relationShip: femaleRelation,
              marriageId
            });
          }}
          className='addlink-anchor-tag'
        >
          {translatedLabels[`Add ${femaleRelation}`].translatedLabel}
        </span>
      </span>
    )
  }

  showCatagorySection({
    forParents,
    forSiblings,
    forChildren,
    forPartners,
    forHR, // Hard return
  }){

    // if(this.props.immediateFamVersion !== 'flipPanel') return true;

    const immediateFam = this.props.nodeObj.immediateFam;
    const children     = immediateFam.children;
    const partners     = immediateFam.partners;
    const parents      = immediateFam.parents;
    const siblings     = immediateFam.siblings;

    if(this.props.immediateFamVersion === 'addbox' && siblings.length <= 1 && this.canAddNode()) return true;
    if(this.props.immediateFamVersion === 'addbox' && partners.length === 0 && this.canAddNode()) return true;
    if(this.props.immediateFamVersion === 'addbox' && children.length === 0 && this.canAddNode()) return true;


    // if(typeof(window.doThisOnce) === 'undefined') window.doThisOnce = false;

    // if(!window.doThisOnce){
    //   window.doThisOnce = true;
      // console.clear();
      // console.log(`immediateFam: `, JSON.stringify(immediateFam, null, 2));

    // }

    const otherThanParents =
      siblings.length <= 1 &&
      partners.length === 0 &&
      children.length === 0

    if((forParents && parents.length === 0) ||
       (forParents && forHR && otherThanParents)
    ) return false;

    if(forSiblings && siblings.length <= 1 ) return false;  // length === 1 cause fetch_immediate will bring in focus node as part of the siblings group
    if(forPartners && typeof(forChildren) === 'undefined' && partners.length === 0) return false;
    if(forChildren && typeof(forPartners) === 'undefined' && children.length === 0) return false;
    if(forChildren && forPartners && partners.length === 0 && children.length > 0  ) return false;
    if(forChildren && forPartners && partners.length === 0 && children.length === 0 ) return false;
    if(forChildren && forPartners && forSiblings && partners.length > 0 && children.length === 0 && siblings.length <= 1) return false;
    if(forChildren && forPartners && typeof(forSiblings) === 'undefined' && partners.length > 0 && children.length === 0 ) return false;

    return true;
  }

  getTbody(){


    const { nodeObj, addNodeFormFocus, openAddNodeForm/*, immediateFamVersion*/ } = this.props;

    if(typeof(nodeObj) === 'undefined') return null;

    let canAddNode = false;
    if(nodeObj.a === 1){
      canAddNode = true;
    }


    return (

      <table
        className='immediateFamTable'
        style={{
          fontSize: '14px',
          width: '100%',
        }}
      >
        <tbody>
          <tr className={`${(this.immediateFamilyIsFetched() && this.showCatagorySection({forParents: true}) ? '': 'hide-header')}`}>
            <td colspan="5" className='family-label'>
              {translatedLabels['Parents'].translatedLabel}&nbsp;&nbsp;
              {

                canAddNode

                ?

                  this.buildAddLinks({
                    openAddNodeForm,
                    maleRelation: 'father',
                    femaleRelation: 'mother',
                    node: addNodeFormFocus
                  })

                :

                  null

              }

            </td>
          </tr>



          {/*
            *
            *
            *
            * Parents
            *
            *
            *
          */}

          { this.getParentsTR() }


          <tr className={`${(this.immediateFamilyIsFetched() && this.showCatagorySection({forParents: true, forHR: true}) ? '': 'hide-header')}`}>
            <td >
             <hr/>
            </td>
          </tr>
          <tr className={`${(this.immediateFamilyIsFetched() && this.showCatagorySection({forSiblings: true}) ? '': 'hide-header')}`}>
            <td className='family-label'>

              {translatedLabels['Siblings'].translatedLabel}&nbsp;&nbsp;

                {

                  canAddNode

                  ?

                   this.buildAddLinks({
                    openAddNodeForm,
                    maleRelation: 'brother',
                    femaleRelation: 'sister',
                    node: addNodeFormFocus
                  })

                  :

                  null
                }

            </td>
          </tr>



          {/*
            *
            *
            *
            * Siblings
            *
            *
            *
          */}

          { this.getSiblingsTR() }



          <tr className={`${(this.immediateFamilyIsFetched() && this.showCatagorySection({forPartners: true, forChildren: true, forSiblings: true}) ? '': 'hide-header')}`}>
            <td >
              <hr/>
            </td>
          </tr>
          <tr className={`${(this.immediateFamilyIsFetched() && this.showCatagorySection({forPartners: true}) ? '': 'hide-header')}`}>
            <td className={`family-label ${ (this.immediateFamilyIsFetched() &&  this.hasOnlyOnePartner()) ? '': 'MultiPartnersTD'} `}>
              {/*( this.immediateFamilyIsFetched() && this.hasOnlyOnePartner() ? 'Partner': 'Partners and Children')*/}
              {( this.immediateFamilyIsFetched() && this.hasOnlyOnePartner() ? translatedLabels['Partner'].translatedLabel: translatedLabels['Partners and Children'].translatedLabel)}
              {( this.immediateFamilyIsFetched() && this.hasOnlyOnePartner() ? <span>&nbsp;&nbsp;</span> : <br/>)}


              {
                  canAddNode && this.props.immediateFamVersion === 'addbox'

                ?


                   this.buildAddLinks({
                    openAddNodeForm,
                    maleRelation: 'husband',
                    femaleRelation: 'wife',
                    node: addNodeFormFocus
                  })

                :
                  null
              }

            </td>
          </tr>

          {/*
            *
            *
            *
            * Partners and Children
            *
            *
            *
          */}

          {

              this.immediateFamilyIsFetched() && this.hasOnlyOnePartner()

            ?

              this.getSinglePartnerDomAndChildrenDom({addNodeFormFocus, canAddNode, openAddNodeForm})

            :

              this.immediateFamilyIsFetched() && this.getMultiplePartnersWithChildrenDom()

          }{

            isMobilePhone()

            ?
              <tr >
                <td id='bufferHeight'>
                </td>
              </tr>

            :

            null

        }
        </tbody>
      </table>
    );
  }

  getImmediateFamilyTableDom(){

    if(this.isFlipPanel) {
      return (
      <Fragment>
          <Radio.Group onChange={(chosenUnionId)=>{ this.chooseParent(chosenUnionId);}} value={this.state.chosenUnionId}>
            {

                this.getTbody()

            }
          </Radio.Group>
      </Fragment>
      )
    } else {
      return this.getTbody();
    }

  }


}

export default Base;

